import {initFaqCarousel} from './faq';
import {initProductDetailsCarousel} from './product-details';
import initProductCrossSell from './product-cross-sell';
import {initMediaCarousel} from './media-carousel';
import {initStackRecommendationsCarousel} from './stack-recommendations';
import {initBuyBox} from './buy-box';
import initJoinUs from '../shared/join-us';

export const initPDPRedesign = () => {
  initBuyBox();
  initProductDetailsCarousel();
  initMediaCarousel();
  initFaqCarousel();
  initProductCrossSell();
  initStackRecommendationsCarousel();
  initJoinUs();
};

